/* eslint-disable */
import React,{useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../../component/Inc/Tab';
import Paging from '../../../component/Inc/Paging';
// import PopClassPlan from './_PopClassPlan';
function ShortReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title:"수업종료 이상", cnt:"45", value:0},
    {title:"상담", cnt:"45", value:1},
    {title:"수업정보 수정", cnt:"45", value:2},
    {title:"학생 태도", cnt:"45", value:3},
    {title:"기타", cnt:"45", value:4},
  ];
  const [modalClassPlan, setModalClassPlan] = useState(false);
  return (
    <main className="com_container p_short_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu1_13'>학생관리<span className="bar"/><span className="point_txt">학생 출석부 (홍학생103ㆍ경기고1ㆍ남)</span></h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalClassPlan(true)} className="com_btn orange s btn_plus">중단 우려회원 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className='com_board_list__top'>
              <section className='com_board_search end'>
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력' className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="4%"/><col width="10%"/>
                <col width="10%"/><col width="10%"/>
                <col width="10%"/><col width="10%"/>
                <col width="10%"/><col width="10%"/>
                <col width="10%"/><col width="10%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>상태</th>
                  <th>학생명</th>
                  <th>휴대폰</th>
                  <th>학교</th>
                  <th>지역</th>
                  <th>지점/학년/계열</th>
                  <th>수업</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>댓글</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>진행</td>
                  <td><button className="btn_link">가학생102</button></td>
                  <td>010-222-1111</td>
                  <td>서울고</td>
                  <td>경기도</td>
                  <td>본사/재수/인문</td>
                  <td>수학</td>
                  <td><button className="btn_link">가교사102</button></td>
                  <td><button className="btn_link">가담임102</button></td>
                  <td>8</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>진행</td>
                      <td><button className="btn_link">가학생102</button></td>
                      <td>010-222-1111</td>
                      <td>서울고</td>
                      <td>경기도</td>
                      <td>본사/재수/인문</td>
                      <td>수학</td>
                      <td><button className="btn_link">가교사102</button></td>
                      <td><button className="btn_link">가담임102</button></td>
                      <td>8</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box type_column">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon gray">수업정보 수정</span>
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20  11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  학생이 수업시간을 옮겨 달라고 하네요.
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon gray">상담</span>
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20  11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  결석이 너무 잦습니다.<br />확인이 필요해 보입니다.
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon red">수업종료 이상</span>
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20  11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                네 확인했습니다.<br />연락해 보겠습니다.
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <span className="com_icon gray">학생 태도</span>
                    <button className="name">김담임102 </button>
                    <span className="desc dot">2025, 05, 20  11 : 30</span>
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  결석이 너무 잦습니다.<br />확인이 필요해 보입니다.
                </div>
              </div>
            </div>
            <div className="com_comment_wrap">
              <hr className="com_divider" />
              <div className="com_input_wrap flex_row">
                <select className="select">
                  <option value="수업정보 수정">수업정보 수정</option>
                </select>
                <select className="select">
                  <option value="메시지 확인자 선택">메시지 확인자 선택</option>
                </select>
              </div>
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder='댓글을 입력해주세요' />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      {/* <PopClassPlan open={modalClassPlan} close={() => setModalClassPlan(false)} /> */}
   </main>
  );
}

export default ShortReport;
